import {
    FETCH_REGIONS_REQUEST,
    FETCH_REGIONS_SUCCESS,
    FETCH_REGIONS_FAILURE,
    FETCH_HCP_TYPES_REQUEST,
    FETCH_HCP_TYPES_SUCCESS,
    FETCH_HCP_TYPES_FAILURE,
    GET_SPECIALITIES_REQUEST,
    GET_SPECIALITIES_SUCCESS, GET_SPECIALITIES_FAILURE, GET_FACILITY_DOCUMENTS, SET_FACILITY_DOCUMENTS,
    OPEN_MODAL,
    CLOSE_MODAL,
    OPEN_LOGIN_MODAL,
    CLOSE_LOGIN_MODAL,
    OPEN_SIGNUP_MODAL,
    CLOSE_SIGNUP_MODAL, SET_LOGIN_VISIBLE, SET_SIGNUP_VISIBLE,
    FETCH_CUSTOMERS_CONFIG_REQUEST,
    FETCH_CUSTOMERS_CONFIG_SUCCESS,
    FETCH_CUSTOMERS_CONFIG_FAILURE,
} from "../actions/meta.action";

export interface MetaParams {
    regions: any[];
    documents: any[];
    isLoading: boolean;
    error: any;
    hcpTypes: any[];
    isHcpTypesLoading: boolean;
    hcpTypesError: any;
    specialitiesMasterList: any[];
    specIsLoading: boolean;
    specError: string | null;
    isModalVisible: boolean;
    isLoginVisible: boolean;
    isSignUpVisible: boolean;
    customersConfig: any[];
    currentCustomerConfig: any;
    isCustomersConfigLoading: boolean;
    customersConfigError: any;
}

const initialData: MetaParams = {
    regions: [],
    documents: [],
    isLoading: true,
    error: null,
    hcpTypes: [],
    isHcpTypesLoading: true,
    hcpTypesError: null,
    specialitiesMasterList: [],
    specIsLoading: false,
    specError: null,
    isModalVisible: false,
    isLoginVisible: false,
    isSignUpVisible: false,
    customersConfig: [],
    currentCustomerConfig: null,
    isCustomersConfigLoading: false,
    customersConfigError: null
};

const metaReducer = (state = initialData, action: any): MetaParams => {
    switch (action.type) {
        case FETCH_REGIONS_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_REGIONS_SUCCESS:
            return {
                ...state,
                regions: action.payload.regions,
                isLoading: false,
            };
        case GET_FACILITY_DOCUMENTS:
            return {
                ...state,
            };
        case SET_FACILITY_DOCUMENTS:
            return {
                ...state,
                documents: action.payload.documents,
            };
        case FETCH_REGIONS_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false,
            };

        case FETCH_HCP_TYPES_REQUEST:
            return {
                ...state,
                isHcpTypesLoading: true
            }
        case FETCH_HCP_TYPES_SUCCESS:
            return {
                ...state,
                hcpTypes: action.payload.hcpTypes,
                isHcpTypesLoading: false
            }
        case FETCH_HCP_TYPES_FAILURE:
            return {
                ...state,
                hcpTypesError: action.payload.hcpTypesError,
                isHcpTypesLoading: false,
            };
        case GET_SPECIALITIES_REQUEST:
            return {
                ...state,
                specIsLoading: true,
                specError: null,
            };
        case GET_SPECIALITIES_SUCCESS:
            return {
                ...state,
                specialitiesMasterList: action.payload,
                specIsLoading: false,
            };
        case GET_SPECIALITIES_FAILURE:
            return {
                ...state,
                specIsLoading: false,
                specError: action.payload,
            };
        case OPEN_MODAL:
            return { ...state, isModalVisible: true };
        case CLOSE_MODAL:
            return { ...state, isModalVisible: false };
        case OPEN_LOGIN_MODAL:
            return { ...state, isLoginVisible: true };
        case CLOSE_LOGIN_MODAL:
            return { ...state, isLoginVisible: false };
        case OPEN_SIGNUP_MODAL:
            return { ...state, isSignUpVisible: true };
        case CLOSE_SIGNUP_MODAL:
            return { ...state, isSignUpVisible: false };
        case SET_LOGIN_VISIBLE:
            return { ...state, isLoginVisible: action.payload };

        case SET_SIGNUP_VISIBLE:
            return { ...state, isSignUpVisible: action.payload };
        case FETCH_CUSTOMERS_CONFIG_REQUEST:
            return {
                ...state,
                isCustomersConfigLoading: true,
            };
        case FETCH_CUSTOMERS_CONFIG_SUCCESS:
            // Find the current customer config based on hostname
            const hostname = window.location.hostname;
            console.log(hostname,"HOST NAME")
            const currentConfig = action.payload.customersConfig.find((config: any) => {
                try {
                    const urlObject = new URL(config?.job_board_url);
                    console.log(urlObject,"HOST NAME")
                    return urlObject.hostname === hostname;
                } catch (error) {
                    console.error("Invalid URL:", config?.job_board_url);
                    return false;
                }
            }) || null;

            return {
                ...state,
                customersConfig: action.payload.customersConfig,
                currentCustomerConfig: currentConfig,
                isCustomersConfigLoading: false,
            };
        case FETCH_CUSTOMERS_CONFIG_FAILURE:
            return {
                ...state,
                customersConfigError: action.payload.error,
                isCustomersConfigLoading: false,
            };
        default:
            return state;
    }
};

export default metaReducer;
